import { playgroundApi } from '../../common/api-client';
import { BaseMonthlyPolicyRow, BasePolicyRow, BaseSavingsInsuranceResponse } from '../_shared';
import { FamilySavingsInsuranceFormValues } from './schema';

export const PRODUCT = 'FAMILY_SAVINGS_INSURANCE';

export interface FamilySavingsPolicyRow extends BasePolicyRow {
  withdrawal?: number;
  policy_value_before_withdrawal?: number;
  policy_value_after_withdrawal?: number;
}

export interface FamilySavingsMonthlyPolicyRow extends BaseMonthlyPolicyRow {
  withdrawal?: number;
  policy_value_before_withdrawal?: number;
  policy_value_after_withdrawal?: number;
}

export interface FamilySavingsInsuranceResponse
  extends BaseSavingsInsuranceResponse<FamilySavingsPolicyRow, FamilySavingsMonthlyPolicyRow> {
  withdrawal_amount?: number;
  withdrawal_period_months?: number;
  terminal_excess?: number;
}

export interface SimulateParams {
  values: FamilySavingsInsuranceFormValues;
}

export async function simulateFamilySavingsInsurance({
  values,
}: SimulateParams): Promise<FamilySavingsInsuranceResponse> {
  const payload = {
    product: PRODUCT,
    origin_process_id: `playground-${crypto.randomUUID().slice(0, 8)}`,
    ...values,
    debug: true,
  };
  const { data } = await playgroundApi.post<FamilySavingsInsuranceResponse>(
    'projection/',
    payload,
  );
  return data;
}
